import React, {useEffect, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import './AlertRuleModal.scss';
import ButtonSpinner from "../_common/ButtonSpinner";
import {toggleModal} from "../../store/actions/toggleModalActions";
import {addRule, updateRule} from "../../store/actions/alertRulesActions";
import MobileAlertRulesThresholdsList from "./MobileAlertRules/MobileAlertRulesThresholdsList";

const selector = state => {
    const { language, disableButtons, alertRules } = state;
    return {
        t: language.translator,
        disableButtons: disableButtons,
        selected: alertRules.selected.alertRule,
        alertMeasurementTypes: alertRules.alertMeasurementTypes,
    }
};

const AlertRuleModal = props => {
    const dispatch = useDispatch();

    const { t, disableButtons, alertMeasurementTypes, selected } = useSelector(selector);

    const {edit, responsive, editThresholdsModal} = props;

    const [measurementType, setMeasurementType] = useState(null)
    const [alertRuleName, setAlertRuleName] = useState('')
    // const [formValues, setFormValues] = useState({})

    const [measurementOptions, showMeasurementOptions] = useState(false);

    useEffect(() => {
      if(edit) {
          setAlertRuleName(selected.ruleName)
          setMeasurementType(alertMeasurementTypes.find(x => x.measurementType === selected.measurementType))
      }
    },[])

    const closeModal = () => {
        dispatch(toggleModal(false, ''));
    };

    const handleAddAlertRuleClick = () => {
        if(measurementType && alertRuleName) {
            let body= {
                ruleName: alertRuleName,
                measurementType: measurementType.measurementType,
            }
            dispatch(addRule(body))
            closeModal()
        }
    }

    const handleEditAlertRuleClick = () => {
        if(measurementType && alertRuleName) {
            let body= {
                ruleName: alertRuleName,
                measurementType: measurementType.measurementType,
                ruleID: selected.ruleID,
                sensorId: selected.sensorId,
                active: selected.active,
            }
            dispatch(updateRule(body))
            closeModal()
        }
    }

    if(responsive) {
        return (
            <div style={{padding: '0', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: 'calc(100% - 20px)'}} className='fieldModalContent'>
                <form className='fieldForm' autoComplete='off'>
                    <div className='fieldFormItem'>
                        <label style={{color: '#95A4B4'}} className='fieldFormLabel'>
                            {t.gettext('Name')}
                        </label>
                        <input
                            className='fieldFormInput'
                            onInput={e => {
                                setAlertRuleName(e.target.value);
                            }}
                            style={{borderColor: "#95A4B4"}}
                            value={alertRuleName}
                            type='text'
                        />
                    </div>
                    <div className='fieldFormItem'>
                        <label style={{color: '#95A4B4'}} className='fieldFormLabel'>
                            {t.gettext('Measurement Type')}
                        </label>
                        <div
                            className='userFormSelect'
                            style={{borderColor: "#95A4B4"}}
                            onClick={() => showMeasurementOptions(!measurementOptions)}
                        >
                            <div className='userFormSelectText'>
                                {measurementType?.measurementTypeName}
                            </div>
                            <i style={{color: "#95A4B4"}} className="material-icons dropDownIcon">
                                {measurementOptions ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                            </i>
                            {measurementOptions &&
                                <div className='userFormSelectOptions'>
                                    {alertMeasurementTypes.map((item, index) => (
                                        <div
                                            className='userFormSelectOption'
                                            key={index}
                                            onClick={() => setMeasurementType(item)}
                                        >
                                            {item.measurementTypeName}
                                        </div>
                                    ))}
                                </div>
                            }
                        </div>
                    </div>
                    {edit  && selected && (
                        <div className="mobileThresholdsWrapper">
                            <MobileAlertRulesThresholdsList
                                item={selected}
                                editMethod={editThresholdsModal}
                            />
                        </div>
                    )}
                </form>

                <div className='fieldButtonsHolder'>
                    <button
                        className='fieldAddButton fieldEditButton'
                        onClick={e => {
                            e.preventDefault();
                            edit ? handleEditAlertRuleClick() :
                                handleAddAlertRuleClick();
                        }}
                        style={{color: "#fff", width: '100%'}}
                        disabled={disableButtons}
                    >
                        {t.gettext('Save')}
                        {disableButtons && <ButtonSpinner black/>}
                    </button>
                </div>
            </div>
        )
    }

    return (
        <div
            onClick={e => {
                if (e.target.className === 'fieldModalBlur') {
                    closeModal()
                }
            }}
            className="fieldModalBlur">
            <div className='fieldModal'>
                <div className='fieldModalHeader'>
                    <div className='fieldModalTitleContainer'>
                        <div className='fieldModalTitle'>
                            {edit ? t.gettext('Edit Alert Rule') : t.gettext('Add Alert Rule')}
                        </div>
                    </div>
                    <div className='fieldModalCloseButtonHolder'>
                        <span
                            className='material-icons fieldModalCloseButton'
                            onClick={closeModal}
                        >
                            cancel
                        </span>
                    </div>
                </div>
                <div className='fieldModalContent'>
                    <form className='fieldForm' autoComplete='off'>
                        <div className='fieldFormItem'>
                            <label className='fieldFormLabel'>
                                {t.gettext('Name')}
                            </label>
                            <input
                                className='fieldFormInput'
                                onInput={e => {
                                    setAlertRuleName(e.target.value);
                                }}
                                value={alertRuleName}
                                type='text'
                            />
                        </div>
                        <div className='fieldFormItem'>
                            <label className='fieldFormLabel'>
                                {t.gettext('Measurement Type')}
                            </label>
                            <div
                                className='userFormSelect'
                                onClick={() => showMeasurementOptions(!measurementOptions)}
                            >
                                <div className='userFormSelectText'>
                                    {measurementType?.measurementTypeName}
                                </div>
                                <i className="material-icons dropDownIcon">
                                    {measurementOptions ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                                </i>
                                {measurementOptions &&
                                    <div className='userFormSelectOptions'>
                                        {alertMeasurementTypes.map((item, index) => (
                                            <div
                                                className='userFormSelectOption'
                                                key={index}
                                                onClick={() => setMeasurementType(item)}
                                            >
                                                {item.measurementTypeName}
                                            </div>
                                        ))}
                                    </div>
                                }
                            </div>
                        </div>
                        <div className='fieldButtonsHolder'>
                            <button
                                className='fieldAddButton fieldEditButton'
                                onClick={e => {
                                    e.preventDefault();
                                    edit ? handleEditAlertRuleClick() :
                                    handleAddAlertRuleClick();
                                }}
                                disabled={disableButtons}
                            >
                                {t.gettext('Save')}
                                {disableButtons && <ButtonSpinner black/>}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default AlertRuleModal
